export default angular
  .module('st.Sms', ['st.Core'])
  .service('smsService', ($q, $http, dataService, SMS) => ({
    addToTicketAsNote: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        SMS.API.ADD_TO_TICKET_AS_NOTE,
        { params },
        ['sms', 'idWorkflow', 'idTicket'],
        true
      ),
    send: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        SMS.API.SEND,
        { params },
        ['sender', 'recipient', 'content'],
        true
      )
  }))
  .constant('SMS', {
    API: {
      ADD_TO_TICKET_AS_NOTE: '/api/v1/sms/add-to-ticket-as-note/',
      SEND: '/api/v1/sms/send/'
    }
  });
